import { ProjectVersionFragment } from '../generated/graphql'
import { sortByProperty } from '../util/array-utility'

export function getProviderIdsToMultipliers(
  versions: ProjectVersionFragment[],
): Record<string, number> {
  const buildings = versions.flatMap((version) => version.buildings)
  return buildings.reduce(
    (records, building) => ({
      ...records,
      ...building.providers.reduce(
        (nestedRecords, provider) => ({
          ...nestedRecords,
          [provider.id]: building.multiplier,
        }),
        {},
      ),
    }),
    {},
  )
}

export type HierarchicalVersion = ProjectVersionFragment & {
  subVersions: HierarchicalVersion[]
}

export function createVersionHierarchy(
  versions: ProjectVersionFragment[],
): HierarchicalVersion[] {
  const sortedVersions = sortByProperty(versions, 'name')

  const mapSubVersions = (
    version: ProjectVersionFragment,
  ): HierarchicalVersion => ({
    ...version,
    subVersions: [
      ...sortedVersions
        .filter((v) => v.baseVersionId === version.id)
        .map(mapSubVersions),
    ],
  })

  return sortedVersions
    .filter((version) => !version.baseVersionId)
    .map(mapSubVersions)
}
